<div class="user-panel">
    <div class="edit-view">
        <form [formGroup]="form" (ngSubmit)="save()" autocomplete="off">
            <div class="panel-content" [class.loading]="loading">
                <app-form-section>
                    <app-form-row>
                        <app-form-group>
                            <label for="email">{{ 'FEATURES.USER.EMAIL' | translate }}</label>
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="email"
                                formControlName="email"
                                type="email"
                                [placeholder]=""
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages"
                                [control]="f.email"
                                languageKey="FEATURES.USER.EMAIL"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row>
                        <app-form-group>
                            <label for="roles">{{ 'FEATURES.USER.ROLES' | translate }}</label>
                            <app-select-roles id="roles" formControlName="roles" />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages"
                                [control]="f.roles"
                                languageKey="FEATURES.USER.ROLES"
                            />
                        </app-form-group>
                    </app-form-row>
                </app-form-section>

                <div class="form-actions">
                    <button type="button" (click)="cancel()">
                        {{ 'BUTTONS.CANCEL' | translate }}
                    </button>
                    <button type="submit" class="primary" [class.loading]="loading" [disabled]="isDisabled()">
                        {{ 'BUTTONS.SAVE' | translate }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
